import MainLayout from '@components/MainLayout/MainLayout'
import Homepage from '@BidftaStrapi/Pages/Homepage'
import { SectionComponent } from '@BidftaStrapi/Components/types'
import { strapiInstance } from '@utilities/axios/strapi'
import organizePageData from '@BidftaStrapi/utils/organizePageData'
import deepMarkdownSerialization from '@BidftaStrapi/utils/deepMarkdownSerialization'
import { formatPageQuery } from '@BidftaStrapi/utils/queryBuilder'
import SEOData from '@BidftaStrapi/Components/SEOData'
import { SEODataType } from '@BidftaStrapi/Components/SEOData/types'
import dynamicPaths from '@BidftaStrapi/utils/dynamicPaths'

export const getStaticPaths = dynamicPaths('campaign')

export async function getStaticProps({
  params: { slug },
}: {
  params: { slug: string }
}) {
  const { data } = await strapiInstance.get(formatPageQuery('campaign', slug))

  const seo = data?.data[0]?.attributes?.landing_page?.data?.attributes ?? null

  const organizedData = organizePageData(data)

  return {
    props: {
      homepage: await deepMarkdownSerialization(organizedData),
      seo,
      slug,
    },
  }
}

const Campaign = ({
  homepage,
  seo,
  slug,
}: {
  seo: SEODataType
  homepage: SectionComponent[][]
  slug: string
}) => {
  return (
    <MainLayout
      title="Online Auctions powered by BidFTA"
      previewDescription="Browse through thousands of online auctions powered by BidFTA at a location near you. Find the best deals on products ranging from home goods to electronics."
      ignoreGlobalSEO={Boolean(seo)}
    >
      <SEOData seoData={seo} />
      <div className="xs:rounded-xl hidden ease-in-out duration-200 text-[48px]" />
      <Homepage
        content={
          slug === 'post-holiday'
            ? [
                [
                  {
                    componentType: 'Video',
                    span: 1,
                    title: {
                      label: 'Watch Our Video',
                    },
                    card: {
                      id: '10',
                      type: 'solid',
                      color: '#ffffff',
                      edges: 'round',
                      position: 'top',
                    },
                  },
                ],
                ...homepage,
              ]
            : homepage
        }
      />
    </MainLayout>
  )
}

export default Campaign
